import React, { useRef, FC, ReactNode, Dispatch } from "react";
import cn from "classnames";
import { useClickOutside } from "src/hooks/useClickOutside";
import { ReactComponent as ArrowBottomIcon } from "src/assets/icons/arrow-bottom-black-medium.svg";

interface Props {
  children: ReactNode;
  head: ReactNode;
  className?: string;
  headClassName?: string;
  bodyClassName?: string;
  isOpen: boolean;
  setIsOpen: Dispatch<React.SetStateAction<boolean>>;
  isActiveIndicatorArrow?: boolean;
}

export const Dropdown: FC<Props> = ({
  children,
  head,
  className,
  headClassName,
  bodyClassName,
  isActiveIndicatorArrow = true,
  isOpen,
  setIsOpen,
}) => {
  const onClose = () => setIsOpen(false);
  const toggleIsOpen = () => setIsOpen((prev) => !prev);

  const dropdownRef = useRef(null);
  useClickOutside(dropdownRef, onClose);

  return (
    <div ref={dropdownRef} className={cn("relative", className)}>
      <div
        className={cn(
          "flex justify-between items-center cursor-pointer",
          headClassName
        )}
        onClick={toggleIsOpen}
      >
        {head}
        {isActiveIndicatorArrow && (
          <ArrowBottomIcon
            className={cn("transition-all duration-200", {
              "rotate-180": isOpen,
            })}
          />
        )}
      </div>
      <div
        className={cn(
          "absolute left-1/2 -translate-x-1/2 invisible -translate-y-1/2 scale-y-0 transition-all duration-200",
          bodyClassName,
          {
            "!visible !translate-y-0 !scale-y-100": isOpen,
          }
        )}
      >
        {children}
      </div>
    </div>
  );
};
